<script>
    import { homeURL, apiURL } from '../../store.js'
    import { fireHashChange } from '../../js/hash-scroll.js'
    export let person
    export let color
</script>

{#if person.category == 'FA'}
    <div class="faculty">
        <div class="imgContainer">
            <img
                src="{apiURL}{person.photo.url}"
                alt="{person.first_name} {person.last_name}"
            />
        </div>
        <div class="meta" style="--pageColor: {color};">
            <div class="name">
                {person.first_name} {person.last_name}
            </div>
            <p class="facultyCurrent">
                {person.current}
            </p>
            {#if person.interests !== ''}
                <p>
                    <span class="bold">
                        Interests:
                    </span>
                    {person.interests}
                </p>
            {/if}
            {#if person.email != ''}
                <p>
                    <span class="bold">
                        Email:
                    </span>
                    <a
                        href="mailto:{person.email}"
                        style="border-bottom: 2px solid {color};"
                    >
                        {person.email.replace('@caltech.edu', '')}
                    </a>
                </p>
            {/if}
            {#if person.cv.url != 'none'}
                <p>
                    <span class="bold">
                        Curriculum Vitae:
                    </span>
                    <a
                        href="{apiURL}{person.cv.url}"
                        target="_blank"
                        style="border-bottom: 2px solid {color};"
                    >
                        Open PDF
                    </a>
                </p>
            {/if}
            {#if person.link.length != 0}
                {#each person.link as link}
                    <a
                        href={link.value.url}
                        rel="noopener noreferrer nofollow"
                        target="_blank"
                    >
                        {link.value.display_text}
                    </a>
                {/each}
            {/if}
            <a
                class="contactLink"
                on:click={e => { fireHashChange(e, 'contact', 'people') }}
                href="{homeURL}/people#!contact"
            >
                Get in contact with the lab.
            </a>
        </div>
    </div>
{:else}
    <div class="person">
        {#if person.photo.url != 'none'}
            <div class="imgContainer">
                <img
                    src="{apiURL}{person.photo.url}"
                    alt="{person.first_name} {person.last_name}"
                />
            </div>
        {:else}
            <div class="emptyImage" />
        {/if}
        <div class="meta">
            <div class="name">
                {person.first_name} {person.last_name}
            </div>
            {#if person.current != 'none'}
                <div class="current">
                    {person.current}
                </div>
            {/if}
            {#if person.interests !== ''}
                <p>
                    <span class="bold">
                        Interests:
                    </span>
                    {person.interests}
                </p>
            {/if}
            {#if person.email != 'none'}
                <p>
                    <span class="bold">
                        Email:
                    </span>
                    <a
                        href="mailto:{person.email}"
                        style="border-bottom: 2px solid {color};"
                    >
                        {person.email.replace('@caltech.edu', '')}
                    </a>
                </p>
            {/if}
            {#if person.link.length != 0}
                {#each person.link as link}
                    <a
                        class="personalLink"
                        href={link.value.url}
                        rel="noopener noreferrer nofollow"
                        target="_blank"
                    >
                        {link.value.display_text}
                    </a>
                {/each}
            {/if}
        </div>
    </div>
{/if}

<style lang="scss">
    @import "../../styles/vars";

    .person {
        grid-column: span 1;
        margin-top: 2rem;

        .imgContainer, .emptyImage {
            position: relative;
            width: 100%;
            height: 0;
            padding-top: 100%;
        }

        .emptyImage {
            background-color: gray;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top:0;
        }

        .current {
            font-family: "Ysabeau";
            margin-bottom: 0.5rem;
            line-height: 1.2rem;
            padding-right: 20px;
        }
    }
    .contactLink {
        font-family: "Ysabeau";
        color: black;
        border-bottom: 2px solid var(--pageColor);
        margin-top: 1rem;
        display: inline-block;

        &:hover {
            text-decoration: none;
        }
    }
    .faculty {
        grid-column: span 3;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 20px;

        .facultyCurrent {
            margin-bottom: 1rem;
        }

        .imgContainer {
            position: relative;
            grid-column: span 1;
            height: 0;
            padding-top: 75%;

            img {
                position: absolute;
                top: 0;
                max-width: 100%;
            }
        }

        .meta {
            grid-column: span 1;
        }
    }
    .name {
        font-family: "Ysabeau";
        font-weight: bold;
        font-size: 1.5rem;
        margin: 0.6rem 0 0.4rem;
    }
    .personalLink {
        font-family: "Ysabeau";
        font-style: italic;
        font-weight: regular;
        color: black;
        font-size: 1rem;
        margin-top: 0.2rem;
        display: block;

        &:hover {
            text-decoration: none;
        }
    }
    .meta p {
        margin: 0;
        font-size: 1rem;
        font-family: "Ysabeau";

        .bold {
            font-weight: bold;
        }

        a {
            border-bottom: 2px solid black;
            color:black;
            text-decoration: none;

            &:hover {
                text-decoration: none;
            }
        }
    }

    @include respond-to(phone) {
        .person {
            margin-top:0;
            margin-bottom: 2rem;
            grid-column: span 3;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            column-gap: 10px;

            .meta {
                grid-column: 2 / 5;

                .name {
                    margin-top: 0;
                    font-size: 1.2rem;
                }
            }

            .imgContainer, .emptyImage {
                grid-column: 1 / 2;
            }
        }
        .faculty {
            .imgContainer {
                grid-column: span 2;
            }

            .meta {
                grid-column: span 2;
            }
        }
    }
</style>
